import ReactDOM from 'react-dom/client'
import './index.css'
import React, { Suspense } from 'react'

const PublicApp = React.lazy(() => import('./public/PublicApp'))
const AdminApp = React.lazy(() => import('./admin/AdminApp'))

function Root() {
    const hostname = window.location.hostname
    const isPublicEventDomain = hostname === 'airvent.page'

    return (
        <Suspense fallback={null}>
            {isPublicEventDomain ? <PublicApp /> : <AdminApp />}
        </Suspense>
    )
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<Root />)